// Константа содержит ID элемента iframe, стили для которого заданы в index.html документе.
export const HELP_EDDY_DESK_IFRAME_ID = 'iframe-help-desk-eddy';
